import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';
import { LoaderInterceptor } from '@shared/interceptors/loader.interceptor';
import { FiscalCodeAvailableAsyncValidator } from '@shared/validators/fiscal-code-available-async.validator';
import { VatNumberAvailableAsyncValidator } from '@shared/validators/vat-number-available-async.validator';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.ConfigurationServiceProxy,
        ApiServiceProxies.AddressServiceProxy,
        ApiServiceProxies.OrderCodeServiceProxy,
        ApiServiceProxies.AtecoCodeServiceProxy,
        FiscalCodeAvailableAsyncValidator,
        VatNumberAvailableAsyncValidator,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
    ],
})
export class ServiceProxyModule {}
